import { useEnvironmentInterface } from "environment-interface";
import { useEffect, useState } from "react";

export const useVisibility = () => {
  const { visibility } = useEnvironmentInterface();
  const [state, setState] = useState(visibility.isVisible);

  useEffect(
    () =>
      visibility.events.subscribe((event) => {
        if (event.type === "VISIBILITY:VISIBLE") {
          setState(true);
        } else {
          setState(false);
        }
      }),
    [visibility.events],
  );

  return state;
};
